import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
  MatSlideToggleChange,
  MatSlideToggleModule,
} from '@angular/material/slide-toggle';
import { EmailIconComponent } from '../../../../email/email-icon/email-icon.component';

@Component({
  selector: 'via-control-panel',
  imports: [MatSlideToggleModule, EmailIconComponent],
  templateUrl: './control-panel.component.html',
  styleUrl: './control-panel.component.scss',
})
export class ControlPanelComponent {
  @Input() isMockData = false;
  @Input() isEditMode = false;
  @Input() allowMockData = false;

  @Output() showConfig: EventEmitter<void> = new EventEmitter<void>();
  @Output() mockDataToggled: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() editModeToggled: EventEmitter<boolean> = new EventEmitter<boolean>();

  onMockDataToggle(event: MatSlideToggleChange) {
    this.mockDataToggled.emit(event.checked);
  }

  onEditModeToggle(event: MatSlideToggleChange) {
    this.editModeToggled.emit(event.checked);
  }
}
